import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { ProgressRow, Step, StepBg } from './styles';

const defaultDuration = 10000;
const progressChangeInterval = 50;

interface ProgressProps {
    count: number;
    currentStep: number;
    isPaused?: boolean;
    onStepComplete: () => void;
    duration?: number;
    isInverted?: boolean;
}

export const Progress: React.FC<ProgressProps> = ({ count, currentStep, isPaused, onStepComplete, duration = defaultDuration, isInverted }) => {
    const [internalStep, setInternalStep] = useState(0);
    const [currentStepProgress, setCurrentStepProgress] = useState(0);

    const steps = useMemo(() => Array.from({ length: count }), [count]);

    const changesCount = duration / progressChangeInterval;
    const increment = 100 / changesCount;

    const updateProgress = useCallback(() => {
        if (!isPaused) {
            setCurrentStepProgress((value) => Math.min(value + increment, 100));
        }
    }, [increment, isPaused]);

    useEffect(() => {
        if (currentStepProgress === 100) {
            onStepComplete();
        }
    }, [onStepComplete, currentStepProgress]);

    useEffect(() => {
        setInternalStep(currentStep);
        setCurrentStepProgress(0);
    }, [currentStep]);

    useEffect(() => {
        const intervalId = window.setInterval(updateProgress, progressChangeInterval);
        return () => clearInterval(intervalId);
    }, [updateProgress]);

    return (
        <ProgressRow>
            {steps.map((_, index) => {
                const progress = index < internalStep ? 100 : index > internalStep ? 0 : currentStepProgress;
                return (
                    <Step key={index}>
                        <StepBg style={{ width: `${progress}%` }} isInverted={isInverted} />
                    </Step>
                );
            })}
        </ProgressRow>
    );
};
